import type {
  AriaAttributes,
  FocusEventHandler,
  InputEvent,
  KeyboardEventHandler,
  MouseEventHandler,
  ReactNode,
} from 'react';
import { forwardRef } from 'react';

import { FlexItem } from '../Flex';
import { Input } from '../InputBox';

type MultiSelectFilteredAnchorProps = {
  children: ReactNode;
  disabled: boolean;
  filter: string;
  onChangeFilter: (filter: string) => void;
  placeholder?: string;
  onClick: MouseEventHandler;
  onBlur: FocusEventHandler;
  onKeyUp: KeyboardEventHandler;
  onKeyDown: KeyboardEventHandler;
  role?: string;
  id?: string;
  name?: string;
} & AriaAttributes;

const MultiSelectFilteredAnchor = forwardRef<
  HTMLInputElement,
  MultiSelectFilteredAnchorProps
>(function MultiSelectFilteredAnchor(
  { children: _children, filter, onChangeFilter, placeholder, ...props },
  ref,
) {
  return (
    <FlexItem grow={1}>
      <Input
        ref={ref}
        placeholder={placeholder}
        value={filter}
        onInput={(e: InputEvent<HTMLInputElement>) =>
          onChangeFilter(e.currentTarget.value)
        }
        {...props}
        rcx-input-box--undecorated
        order={1}
        autoComplete='off'
      />
    </FlexItem>
  );
});

export default MultiSelectFilteredAnchor;
